import React, { forwardRef } from 'react';

import { SvgIconProps } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import variables from 'styles/variabels.module.scss';
import CloseIcon from '@mui/icons-material/Close';

interface Props extends SvgIconProps {
  value: boolean;
}

export const TemplateBooleanIcon = forwardRef<SVGSVGElement, Props>(({ value, ...rest }, ref) => {
  return value ? (
    <CheckIcon ref={ref} {...rest} style={{ color: variables.colorGreen, ...rest?.style }} />
  ) : (
    <CloseIcon ref={ref} {...rest} style={{ color: variables.colorRed, ...rest?.style }} />
  );
});
